exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ":host{display:inline-block}button{padding-left:7px;padding-right:7px}", "", {"version":3,"sources":["/srv/projects/jsapp/src/app/core/user-menu/user-menu.component.css"],"names":[],"mappings":"AAAA,MACE,oBAAsB,CACvB,OAGC,iBAAkB,iBACC,CACpB","file":"user-menu.component.css","sourcesContent":[":host{\n  display: inline-block;\n}\n\nbutton{\n  padding-left: 7px;\n  padding-right: 7px;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /srv/projects/jsapp/src/app/core/user-menu/user-menu.component.css
// module id = H2Qv
// module chunks = 6